import { render, staticRenderFns } from "./TipsSwitchSimulator.vue?vue&type=template&id=37689482&scoped=true&"
import script from "./TipsSwitchSimulator.vue?vue&type=script&lang=js&"
export * from "./TipsSwitchSimulator.vue?vue&type=script&lang=js&"
import style0 from "./TipsSwitchSimulator.vue?vue&type=style&index=0&id=37689482&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37689482",
  null
  
)

export default component.exports